export default "__VITE_ASSET__82edd421__"